import styled from 'styled-components';

const ValueItemWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0.5em;
  p {
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    box-sizing: border-box;
    padding-left: 0.8em;
  }
`;

const CampusesSelectWrapper = styled.div`
  .rw-list-option {
    padding: 1em;
    &:first-of-type {
      position: relative;
      &:after {
        display: ${p => (p.hideFirstElBorder ? 'none' : 'block')};
        width: 100%;
        height: 1px;
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        background: ${p => p.theme.color.border};
      }
    }
  }
  .rw-popup ul {
    max-height: inherit;
  }
  .select-field {
    margin-bottom: 0;
  }
  ${p => p.disabled &&
    ` pointer-events: none;
      .rw-widget-input {
        background: ${p.theme.color.background};
        > *{
          opacity: .5;
        }
      }
   `};
`;

export default {
  ValueItemWrapper,
  CampusesSelectWrapper
};